import { WinLinesCyclingCondition } from '@cgs/machines';
import { Container } from '@cgs/wge';
import { TRIFECTA_GAME_HOOK_TOKEN, TrifectaGameHook } from '../game-hook/trifecta-game-hook';

/**
 * During SDK-driven autoplay the next spin starts right after the round is
 * acknowledged, so the win line loop in regularSpins would be cut off
 * immediately — suppress it and keep only the single pass from shortWinLines.
 */
export class TrifectaWinLinesCyclingCondition implements WinLinesCyclingCondition {
  constructor(private readonly container: Container) {}

  public get isCyclingAllowed(): boolean {
    const gameHook = this.container.resolve<TrifectaGameHook>(TRIFECTA_GAME_HOOK_TOKEN);

    return !gameHook.autoPlayChanged.state;
  }
}
